module.exports = __webpack_public_path__ + "static/media/server_1.0be25a7e.png";